import 'firebaseui/dist/firebaseui.css'
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import { useAuth } from "reactfire";
import '../App.css'
import landingImage from '../img/landing.png'

// compat SDK needed for FirebaseUI
import firebase from "firebase/compat/app";
import "firebase/compat/auth";

function AuthSetup() {

	// var signInCheckResult = { signedIn: false };

	var uiConfig = {
		signInFlow: 'popup',
		signInOptions: [
			// Leave the lines as is for the providers you want to offer your users.
			firebase.auth.GoogleAuthProvider.PROVIDER_ID,
			firebase.auth.EmailAuthProvider.PROVIDER_ID
		],
		callbacks: {
			// Avoid redirects after sign-in.
			signInSuccessWithAuthResult: () => false,
		}
	}

	const v9AuthInstance = useAuth();
	const v8AppInstance = firebase.initializeApp(v9AuthInstance.app.options);
	const v8AuthInstance = v8AppInstance.auth();

	// var showCheck = signInCheckResult !== undefined && signInCheckResult.signedIn !== false
	return (
		<div className='authHeader'>
			<h1>Sign in to Journaloop</h1>
			<StyledFirebaseAuth firebaseAuth={v8AuthInstance} uiConfig={uiConfig} />
			<div className="landing-background"></div>
			<img className='landing-img' src={landingImage} alt="" />
			<div className="landing-caption">Track your mood, activities, and journal entries with smart analytics to improve your life!</div>
		</div>
	)
}

export default AuthSetup;